import type { AuditEventApi } from '@env0/audit-service/api';
import type { HttpClient } from 'services/api-client/client';
import type { AuditLog } from 'types/api.types';
import { returnData } from 'services/api-client/client';
import isEmpty from 'lodash/isEmpty';

type AuditLogQueryParams = AuditEventApi.FetchAuditLogs.Request.QueryParams;

export type AuditLogFilters = Pick<AuditLogQueryParams, 'from' | 'to' | 'entityId' | 'order'> & {
  userIds?: string[];
  excludeUserIds?: string[];
  projectIds?: string[];
  excludeProjectIds?: string[];
  entityTypes?: string[];
  actionNames?: string[];
  excludeActionNames?: string[];
  sources?: string[];
};

export type AuditLogsPage = { events: AuditLog[]; nextPageKey?: string; searchedUntil?: string };

const joinList = (values?: string[]) => (isEmpty(values) ? undefined : values?.join(','));

export default (client: HttpClient) => ({
  findByOrganizationId: (
    organizationId: string,
    pageKey?: string,
    {
      userIds,
      excludeUserIds,
      projectIds,
      excludeProjectIds,
      entityTypes,
      actionNames,
      excludeActionNames,
      sources,
      ...filters
    }: AuditLogFilters = {}
  ) =>
    client
      .get<AuditLogsPage>('audit/events', {
        params: {
          organizationId,
          offset: pageKey,
          ...filters,
          userIds: joinList(userIds),
          excludeUserIds: joinList(excludeUserIds),
          projectIds: joinList(projectIds),
          excludeProjectIds: joinList(excludeProjectIds),
          entityTypes: joinList(entityTypes),
          actionNames: joinList(actionNames),
          excludeActionNames: joinList(excludeActionNames),
          sources: joinList(sources)
        }
      })
      .then(returnData)
});
